<template>
  <el-dialog
    v-el-drag-dialog
    no="ContactPerson"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.BillOfLadingDesignatedFreightAgentFeedback')"
    :close-on-click-modal="false"
    width="830px"
    @close="dialogClose"
  >
    <div>
      <!-- 表格内容 -->
      <table class="table">
        <!-- 表格行和单元格 -->
        <tr>
          <td class="centered-cell w-50">{{ $t('SeaExport.SequenceNumber') }}</td>
          <td class="centered-cell w-100">{{ $t('FinanceManage.modifyField') }}</td>
          <td class="left-aligned-cell w-300">{{ $t('SeaExport.ChangeValue') }}</td>
          <td class="left-aligned-cell w-300">{{ $t('CargoMsg.Cargo_OriginalValue') }}</td>
        </tr>
        <tr>
          <td class="centered-cell">{{ '1' }}</td>
          <td class="centered-cell">{{ $t('SeaExport.Shipper') }}</td>
          <td class="left-aligned-cell w-300 h-110">
            <p>{{ data.feedbackShipperLine1 }}</p>
            <p>{{ data.feedbackShipperLine2 }}</p>
            <p>{{ data.feedbackShipperLine3 }}</p>
            <p>{{ data.feedbackShipperLine4 }}</p>
            <p>{{ data.feedbackShipperLine5 }}</p>
            <p>{{ data.feedbackShipperLine6 }}</p>
            <p>{{ data.feedbackShipperLine7 }}</p>
          </td>
          <td class="left-aligned-cell w-300 h-110">
            <p>{{ data.shipperLine1 }}</p>
            <p>{{ data.shipperLine2 }}</p>
            <p>{{ data.shipperLine3 }}</p>
            <p>{{ data.shipperLine4 }}</p>
            <p>{{ data.shipperLine5 }}</p>
            <p>{{ data.shipperLine6 }}</p>
            <p>{{ data.shipperLine7 }}</p>
          </td>
        </tr>
        <tr>
          <td class="centered-cell">{{ '2' }}</td>
          <td class="centered-cell">{{ $t('SeaExport.Consignee') }}</td>
          <td class="left-aligned-cell w-300 h-110">
            <p>{{ data.feedbackConsigneeLine1 }}</p>
            <p>{{ data.feedbackConsigneeLine2 }}</p>
            <p>{{ data.feedbackConsigneeLine3 }}</p>
            <p>{{ data.feedbackConsigneeLine4 }}</p>
            <p>{{ data.feedbackConsigneeLine5 }}</p>
            <p>{{ data.feedbackConsigneeLine6 }}</p>
            <p>{{ data.feedbackConsigneeLine7 }}</p>
          </td>
          <td class="left-aligned-cell w-300 h-110">
            <p>{{ data.consigneeLine1 }}</p>
            <p>{{ data.consigneeLine2 }}</p>
            <p>{{ data.consigneeLine3 }}</p>
            <p>{{ data.consigneeLine4 }}</p>
            <p>{{ data.consigneeLine5 }}</p>
            <p>{{ data.consigneeLine6 }}</p>
            <p>{{ data.consigneeLine7 }}</p>
          </td>
        </tr>
        <tr>
          <td class="centered-cell">{{ '3' }}</td>
          <td class="centered-cell">{{ $t('SeaExport.NotifyParty') }}</td>
          <td class="left-aligned-cell w-300 h-110">
            <p>{{ data.feedbackNotifyLine1 }}</p>
            <p>{{ data.feedbackNotifyLine2 }}</p>
            <p>{{ data.feedbackNotifyLine3 }}</p>
            <p>{{ data.feedbackNotifyLine4 }}</p>
            <p>{{ data.feedbackNotifyLine5 }}</p>
            <p>{{ data.feedbackNotifyLine6 }}</p>
            <p>{{ data.feedbackNotifyLine7 }}</p>
          </td>
          <td class="left-aligned-cell w-300 h-110">
            <p>{{ data.notifyLine1 }}</p>
            <p>{{ data.notifyLine2 }}</p>
            <p>{{ data.notifyLine3 }}</p>
            <p>{{ data.notifyLine4 }}</p>
            <p>{{ data.notifyLine5 }}</p>
            <p>{{ data.notifyLine6 }}</p>
            <p>{{ data.notifyLine7 }}</p>
          </td>
        </tr>
        <tr>
          <td class="centered-cell h-25">{{ '4' }}</td>
          <td class="centered-cell">{{ $t('SeaExport.PortOfLoadingOnBl') }}</td>
          <td class="left-aligned-cell w-300">{{ data.feedbackLoadingPort }}</td>
          <td class="left-aligned-cell w-300">{{ data.loadingPort }}</td>
        </tr>
        <tr>
          <td class="centered-cell h-25">{{ '5' }}</td>
          <td class="centered-cell">{{ $t('SeaExport.BillPortOfDischarge') }}</td>
          <td class="left-aligned-cell w-300">{{ data.feedbackDischargingPort }}</td>
          <td class="left-aligned-cell w-300">{{ data.dischargingPort }}</td>
        </tr>
        <tr>
          <td class="centered-cell h-25">{{ '6' }}</td>
          <td class="centered-cell">{{ $t('SeaExport.BillLadingPlaceOfDelivery') }}</td>
          <td class="left-aligned-cell w-300">{{ data.feedbackDestinationPort }}</td>
          <td class="left-aligned-cell w-300">{{ data.destinationPort }}</td>
        </tr>
        <tr>
          <td class="centered-cell h-110">{{ '7' }}</td>
          <td class="centered-cell">{{ $t('SeaExport.CommodityName') }}</td>
          <td class="left-aligned-cell w-300">{{ data.feedbackCargoEnglishName }}</td>
          <td class="left-aligned-cell w-300">{{ data.cargoEnglishName }}</td>
        </tr>
        <tr>
          <td class="centered-cell h-110">{{ '8' }}</td>
          <td class="centered-cell">{{ $t('SeaExport.Marks') }}</td>
          <td class="left-aligned-cell w-300">{{ data.feedbackMark }}</td>
          <td class="left-aligned-cell w-300">{{ data.mark }}</td>
        </tr>
      </table>
    </div>
    <div class="tips">
      <span v-if="data.status === 1" class="block-span">{{ $t('SeaExport.AgentFeedbackRemarks1') }}</span>
      <span v-if="data.status === 2" class="block-span">{{ $t('SeaExport.AgentFeedbackRemarks2') }}</span>
      <span v-if="data.status === 2" class="block-span">{{ $t('SeaExport.AgentFeedbackRemarks3') }}</span>
    </div>
    <div slot="footer">
      <el-button v-if="data.status === 0" no="1" type="danger" class="button-left" @click="rejected">{{ $t('SeaExport.Rejected') }}</el-button>
      <el-button v-if="data.status === 0" no="2" type="primary" @click="confirm">{{ $t('SeaExport.AcceptChange') }}</el-button>
      <el-button no="3" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { xhqAcceptOverseasAgentFeedback, xhqNotAcceptOverseasAgentFeedback } from '@/api/seaExport/seaCargoDoc'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'XhqOverseasAgentFeedbackDialog',
  props: {
    visible: { type: Boolean, default: false },
    data: { type: Object, default: null },
    callback: { type: Function, default: null }
  },
  data() {
    return {
      innerVisible: false,
      loading: false
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.onShow()
    }
  },
  methods: {
    dialogClose() {
      this.$emit('update:visible', false)
    },
    onShow() {

    },
    cancel() {
      this.$emit('update:visible', false)
    },
    confirm() {
      this.loading = getLoading4Cxt()
      xhqAcceptOverseasAgentFeedback(this.data).then(res => {
        this.$message.success(this.$t('Message.Success'))
        if (this.callback) {
          this.callback(true)
        }
        this.$emit('update:visible', false)
      }).catch(() => {
      }).finally(() => {
        this.loading.close()
      })
    },
    rejected() {
      xhqNotAcceptOverseasAgentFeedback(this.data).then(res => {
        this.$message.success(this.$t('Pricing.Refused'))
        this.$emit('update:visible', false)
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
.table {
  margin: 0 auto;
  border-collapse: collapse; /* 合并边框 */
  height: 100%;
}

td {
  border: 1px solid #ccc;
  height: 100%;
  padding: 2px;
}
p {
  margin: 1px;
}
.tips {
  margin-left: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
  color: orange;
  display: block;
}
.block-span {
  display: block;
}
.w-50 {
  width: 50px;
}
.w-100 {
  width: 100px;
}
.w-300 {
  width: 300px;
}
.h-25 {
  height: 25px;
}
.h-110 {
  height: 110px;
}
.centered-cell {
  text-align: center; /* 文字居中对齐 */
}
.left-aligned-cell {
  text-align: left;
}
.button-left {
  float: left;
  margin-left: 30px;
}
</style>
